import Vue from 'vue'
import $x from '../js/$x'
/*
用法：
<div v-longtouch="selector" @longtouch="funcHandler"></div>
* */
var _delay = 800;
const _maxMove = 30;
Vue.directive('longtouch', {
    bind(el, binding) {
        let timer = null;
        let startX, startY;
        const $el = $x(el);
        const handler = binding.value;

        function onStart(e) {
            if (e.touches.length !== 1) return;
            const touch = e.touches[0];

            startX = touch.screenX;
            startY = touch.screenY;

            timer = setTimeout(function () {
                onStop();
                if (handler) {
                    handler(e)
                } else {
                    const evt = document.createEvent('Event');
                    evt.initEvent('longtouch', true, true);
                    el.dispatchEvent(evt)
                }
            }, _delay);
            $el.on('touchmove', onMove);
            $el.on('touchend', onStop);
        }

        function onMove(e) {
            if (e.touches.length !== 1) return;
            const touch = e.touches[0];
            const distance = Math.abs(touch.screenX - startX) + Math.abs(touch.screenY - startY);
            if (distance > _maxMove) {
                onStop()
            }
        }

        function onStop() {
            clearTimeout(timer);
            // $el.off('touchstart', onStart)
            $el.off('touchend', onStop);
            $el.off('touchend', onMove)
        }

        $el.on('touchstart', onStart);
        $el.on('contextmenu', e => e.preventDefault());
    }
})
